<form [formGroup]="addressInfoForm" [ngClass]="{ submitted: formSubmitted }">
  <div
    class="layout"
    fxLayout="column"
    fxLayoutAlign="center center"
    style="height: 100%"
    >
    <!-- First Row -->
    <div
      fxLayout="row"
      fxLayout.lt-lg="column"
      fxLayoutAlign="start center"
      class="label-row large-screen w-100"
      >
      <div
        fxLayout="column"
        fxFlex="60"
        class="add-patient-col w-100"
        fxLayoutAlign="center start"
        >
        <div>
          {{ "Street" | translate }}
          <span class="optional">{{ "(optional)" | translate }}</span>
        </div>
        <input
          class="add-patient-input"
          [placeholder]="'Street' | translate"
          formControlName="addressStreet"
          [maxLength]="51"
          />
        </div>

        <div
          fxLayout="column"
          fxFlex="20"
          class="add-patient-col w-100"
          fxLayoutAlign="center start"
          >
          <div>
            {{ "Street Number" | translate }}
            <span class="optional">{{ "(optional)" | translate }}</span>
          </div>
          <input
            class="add-patient-input"
            [placeholder]="'Street Number' | translate"
            formControlName="addressStreetNumber"
            [maxLength]="31"
            />
          </div>

          <div
            fxLayout="column"
            fxFlex="20"
            class="add-patient-col w-100"
            fxLayoutAlign="center start"
            >
            <div>
              {{ "Apartment Number" | translate }}
              <span class="optional">{{ "(optional)" | translate }}</span>
            </div>
            <input
              class="add-patient-input"
              [placeholder]="'Apartment Number' | translate"
              formControlName="addressApartmentNumber"
              [maxLength]="31"
              />
            </div>
          </div>

          <!-- Second Row -->
          <div
            fxLayout="row"
            fxLayout.lt-lg="column"
            fxLayoutAlign="center center"
            class="label-row large-screen w-100"
            >
            <div
              fxLayout="column"
              fxFlex="25"
              class="add-patient-col w-100"
              fxLayoutAlign="center start"
              >
              <div>
                {{ "Postcode" | translate }}
                <span class="optional">{{ "(optional)" | translate }}</span>
              </div>
              <input
                class="add-patient-input"
                [placeholder]="'Postcode' | translate"
                formControlName="addressPostCode"
                [maxLength]="31"
                />
              </div>

              <div
                fxLayout="column"
                fxFlex="25"
                class="add-patient-col w-100"
                fxLayoutAlign="center start"
                >
                <div>
                  {{ "Country" | translate }}
                  <span class="optional">{{ "(optional)" | translate }}</span>
                </div>
                <nz-select
                  class="add-patient-inputZorro"
                  nzShowSearch
                [appTerminologySearch]="countriesList"
                  nzAllowClear
                  [nzPlaceHolder]="'Country' | translate"
                  formControlName="addressCountryId"
                  (ngModelChange)="onCountryChange($event)"
                  >
                  @for (place of countriesList; track place) {
                    <nz-option [nzLabel]="place.name" [nzValue]="place.id"></nz-option>
                  }
                </nz-select>
              </div>

              <div
                fxLayout="column"
                fxFlex="25"
                class="add-patient-col w-100"
                fxLayoutAlign="center start"
                >
                <div>
                  {{ "Town" | translate }}
                  <span class="optional">{{ "(optional)" | translate }}</span>
                </div>
                @if (!isCountryCyprus) {
                  <input
                    class="add-patient-input"
                    [placeholder]="'Town' | translate"
                    formControlName="addressTown"
                    [maxLength]="51"
                    />
                  } @else {
                    <nz-select
                      class="add-patient-inputZorro"
                      nzShowSearch
                      nzAllowClear
                      [nzPlaceHolder]="'Select a Town' | translate"
                      formControlName="addressTown"
                      >
                      @for (city of cyprusCities; track city) {
                        <nz-option
                          [nzLabel]="city | translate"
                          [nzValue]="city"
                        ></nz-option>
                      }
                    </nz-select>
                  }
                  <!-- Dropdown if Cyprus -->
                </div>
                <div
                  fxLayout="column"
                  fxFlex="25"
                  class="add-patient-col w-100"
                  fxLayoutAlign="center start"
                  >
                  <div>
                    {{ "District" | translate }}
                    <span class="optional">{{ "(optional)" | translate }}</span>
                  </div>
                  <input
                    class="add-patient-input"
                    [placeholder]="'District' | translate"
                    formControlName="addressDistrict"
                    [maxLength]="51"
                    />
                  </div>
                </div>
              </div>
            </form>
